import FocusTrap from 'bootstrap/js/src/util/focustrap';
import switchLinksTabIndex from '../utils/switchLinksTabIndex';

export default function () {
  const hamburgerButtons = document.querySelectorAll('[data-header-hamburger]');
  const closeButtons = document.querySelectorAll('[data-close-nav-btn]');
  const nav = document.querySelectorAll('[data-nav]');
  const navOpenClass = 'nav--open';
  const wrapper = document.querySelectorAll('[data-wrapper]');
  const { body } = document;
  const bodyNavVisibleClass = 'nav-visible';

  nav.forEach((item) => {
    switchLinksTabIndex(item, -1);
  });

  const openNav = () => {
    nav.forEach((item) => {
      const focustrap = new FocusTrap({
        trapElement: item,
      });

      switchLinksTabIndex(item, 0);
      focustrap.activate();

      item.classList.add(navOpenClass);
    });

    wrapper.forEach((item) => {
      item.classList.add(bodyNavVisibleClass);
    });

    body.classList.add(bodyNavVisibleClass);
  };

  const closeNav = () => {
    nav.forEach((item) => {
      const focustrap = new FocusTrap({
        trapElement: item,
      });

      switchLinksTabIndex(item, -1);
      focustrap.deactivate();

      item.classList.remove(navOpenClass);
    });

    wrapper.forEach((item) => {
      item.classList.remove(bodyNavVisibleClass);
    });

    body.classList.remove(bodyNavVisibleClass);
  };

  const toggleNav = () => {
    if (body.classList.contains(bodyNavVisibleClass)) {
      closeNav();
    } else {
      openNav();
    }
  };

  hamburgerButtons.forEach((button) => {
    button.addEventListener('click', toggleNav);
  });

  closeButtons.forEach((button) => {
    button.addEventListener('click', closeNav);
  });

  window.addEventListener('orientationchange', closeNav);
}
